import { useCallback, useEffect, useRef } from "react";

/**
 * Creates object URLs for Blobs, revoking the previous one on replacement
 * and the last one on unmount so callers can't leak them.
 */
export function useRevocableObjectUrl() {
  const activeUrlRef = useRef<string | null>(null);

  const createObjectUrl = useCallback((blob: Blob) => {
    if (activeUrlRef.current) URL.revokeObjectURL(activeUrlRef.current);
    const objectUrl = URL.createObjectURL(blob);
    activeUrlRef.current = objectUrl;
    return objectUrl;
  }, []);

  useEffect(() => {
    return () => {
      if (activeUrlRef.current) URL.revokeObjectURL(activeUrlRef.current);
    };
  }, []);

  return createObjectUrl;
}
